import React, {
  Component,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { setLoading, saveData } from "../OrdersList/actions";
import OrdersListComp from "./component";
import throttle from "lodash.throttle";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { setCityFilter, setAmountFilter } from "../OrdersList/actions";
import Tesseract from "tesseract.js";
import { createWorker } from "tesseract.js";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import _ from "lodash";
import moment from "moment-timezone";

const OrderListContainer = (props) => {
  const {
    cityList,
    amountList,
    setCityFilter,
    setAmountFilter,
    getDataFromAPI,
  } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const [data, setData] = useState([]);
  const [searchOrderList, setSearchOrderList] = useState([]);
  // const [cityList, setCityList] = useState(null);
  const [searchOrderValue, setSearchOrderValue] = useState();
  // const [loading, setLoading] = useState(false);
  const [searchOrderData, setSearchOrderData] = useState(null);
  const [from_timestamp, setFrom_timestamp] = useState(moment().tz("UTC"));
  const [to_timestamp, setTo_timestamp] = useState(moment().tz("UTC"));
  const [morescroll, setMorescroll] = useState(true);
  const [start, setStart] = useState(0);
  const [SelectedDate, setSelectedDate] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dragActive, setDragActive] = React.useState(false);

  const [previewImage, setPreviewImage] = useState(null);
  const [imageDropped, setImageDropped] = useState(false);
  const inputRef = useRef(null);
  const [imagePath, setImagePath] = useState("");
  const [text_ocr, setText] = useState("");
  const [orderID, setOrderID] = useState("-1");
  const [orderFound, setOrderFound] = useState(true);
  const [orderId, setOrderId] = useState();
  const [retryClicked, setRetryClicked] = useState(false);
  const [showFileInput, setShowFileInput] = useState(false);
  const [SelectedFile, setSelectedFile] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchOption, setSearchOption] = useState("");
  const [cityData, setCityData] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [searchCityValue, setSearchCityValue] = useState("");
  const [filteredCityList, setFilteredCityList] = useState(null);
  const [searchAmountValue, setSearchAmountValue] = useState(null);
  const [filteredAmountList, setFilteredAmountList] = useState(null);
  const [openFilterAmount, setOpenFilterAmount] = useState(false);
  const [pickDate, setPickDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const loadingRef = useRef(isLoading);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedAmount, setSelectedAmounts] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [filtering, setFiltering] = useState(false);


  
  const handleAmountInputChange = (e) => {
    const value = e.target.value;
    
    
    if (value.length <= 5) {
      setSearchAmountValue(value);
    }
  };
  
  useEffect(() => {
    if (cityList && cityList.length > 0) {
      const selectedCity = cityList[0];
      getDataFromAPI(
        `/api/orders?city=${selectedCity}`,
        "GET",
        null,
        (response) => {
          // handle response
        }
      );
    }
  }, [cityList]);

  useEffect(() => {
    if (amountList && amountList.length > 0) {
      const selectedAmount = amountList[0];
      getDataFromAPI(
        `/api/orders?amount=${selectedAmount}`,
        "GET",
        null,
        (response) => {
          
        }
      );
    }
  }, [amountList]);

  function handleFilterClick() {
    setShowDatePicker(!showDatePicker);
  }

  useEffect(() => {
    if (
      pickDate &&
      startTime &&
      endTime &&
      moment(pickDate).isValid() &&
      moment(startTime).isValid() &&
      moment(endTime).isValid()
    ) {
      setFrom_timestamp(
        moment(pickDate)
          .set({
            hour: startTime.get("hour"),
            minute: startTime.get("minute"),
            second: 0,
          })
          .tz("UTC")
      );

      setTo_timestamp(
        moment(pickDate)
          .set({
            hour: endTime.get("hour"),
            minute: endTime.get("minute"),
            second: 59,
          })
          .tz("UTC")
      );
    }
  }, [pickDate, startTime, endTime]);

  const handleDateChange = (newValue) => {
    setPickDate(newValue ? moment(newValue).tz("IST") : null);
  };

  const handleStartTimeChange = (newValue) => {
    if (newValue && pickDate) {
      const updatedStartTime = moment(newValue)
        .tz("IST")
        .set({
          year: pickDate.get("year"),
          month: pickDate.get("month"),
          date: pickDate.get("date"),
        });
      setStartTime(updatedStartTime);
    } else {
      setStartTime(null);
    }
  };

  const handleEndTimeChange = (newValue) => {
    if (newValue && pickDate) {
      const updatedEndTime = moment(newValue)
        .tz("IST")
        .set({
          year: pickDate.get("year"),
          month: pickDate.get("month"),
          date: pickDate.get("date"),
        });
      setEndTime(updatedEndTime);
    } else {
      setEndTime(null);
    }
  };

  const handleCancelSelection = () => {
    setPickDate(null);
    setStartTime(null);
    setEndTime(null);
    setFrom_timestamp(null);
    setTo_timestamp(null);
    setSearchAmountValue(null);
   
    setCurrentPage(0); 
  
    if (searchOrderValue) {
      orderSearch(searchOrderValue); 
    }
  };

  const generateQueryParams = (from_utc_timestamp, to_utc_timestamp, amount) => {
    let queryParams = `/partner/api/v1/admin/orders?search_query=${searchOrderValue}&page_number=${currentPage}&page_size=20`;
  
    if (from_utc_timestamp && to_utc_timestamp) {
      const fromTimestamp = from_utc_timestamp.format("YYYY-MM-DD HH:mm:ss");
      const toTimestamp = to_utc_timestamp.format("YYYY-MM-DD HH:mm:ss");
      queryParams += `&from_timestamp=${encodeURIComponent(fromTimestamp)}&to_timestamp=${encodeURIComponent(toTimestamp)}`;
    }
  
    if (amount) {
      queryParams += `&amount=${amount}`;
    }
  
    return queryParams;
  };

  const handleApplyFilter = () => {
    if (!searchAmountValue && !pickDate && !startTime && !endTime) {
      toastr.error("Please apply at least one filter (date, time, or amount).", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      return;
    }
  
    setFiltering(true); 
    setSearchOrderList([]); 
    setCurrentPage(0); 
    handleApply();
  };
  
  
  
  const handleApply = () => {
    if (isLoading) return;
  
    setIsLoading(true);
  
    const now = moment().tz("UTC");
    let from_utc_timestamp;
    let to_utc_timestamp;
  
    if (!pickDate && !startTime && !endTime) {
     
      const last30Days = moment().tz("UTC").subtract(30, 'days');
      from_utc_timestamp = last30Days;
      to_utc_timestamp = now;
    } else {
      const start = startTime || moment(pickDate).set({ hour: 0, minute: 0, second: 0 }).tz("IST");
      const end = endTime || moment(pickDate).set({ hour: 23, minute: 59, second: 59 }).tz("IST");
  
      if (end.isSameOrBefore(start)) {
        toastr.error("End time should be after start time.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setIsLoading(false);
        return;
      }
  
      from_utc_timestamp = moment.tz(
        `${pickDate && pickDate.format("YYYY-MM-DD")} ${start.format("HH:mm:ss")}`,
        "YYYY-MM-DD HH:mm:ss",
        "Asia/Kolkata"
      ).tz("UTC");
  
      to_utc_timestamp = moment.tz(
        `${pickDate && pickDate.format("YYYY-MM-DD")} ${end.format("HH:mm:ss")}`,
        "YYYY-MM-DD HH:mm:ss",
        "Asia/Kolkata"
      ).tz("UTC");
    }
  
    setFrom_timestamp(from_utc_timestamp);
    setTo_timestamp(to_utc_timestamp);
  
    const queryParams = generateQueryParams(from_utc_timestamp, to_utc_timestamp, searchAmountValue);
  
    props.getDataFromAPI(
      queryParams,
      "GET",
      undefined,
      (response) => {
        if (response && response.length > 0) {
          setSearchOrderList(response); 
          setMorescroll(true); 
        } else {
          setSearchOrderList([]); 
          setMorescroll(false); 
        }
        setFiltering(false); 
        setIsLoading(false);
        handleFilterClick(false); 
      },
      (err) => {
        setFiltering(false); 
        setIsLoading(false);
        toastr.error(`${err.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }
    );
  };
  
 
  
  
  

  const handleFocus = () => {
    setIsFocused(true);
  };

  const rowColors = [
    "#E0FAF1",
    "#FF00A921",
    "#713ABA2E",
    "#A9CFF354",
    "#FF00A921",
  ];

  const handleSearchOptionChange = (event) => {
    setSearchOption(event.target.value);
    setSearchOrderValue("");
  };

  const AUTO_REMOVE_TIME = 60 * 60 * 1000;

  const onSearchInputChange = (e) => {
    const searchName = e.target.value;

    sessionStorage.setItem("searchName", searchName);
    sessionStorage.setItem("searchTimestamp", Date.now().toString());
    setSearchOrderValue(searchName);
  };

  useEffect(() => {
    const storedSearchName = sessionStorage.getItem("searchName");
    const storedTimestamp = sessionStorage.getItem("searchTimestamp");

    if (storedSearchName && storedTimestamp) {
      const currentTime = Date.now();
      const timeElapsed = currentTime - parseInt(storedTimestamp, 10);

      if (timeElapsed < AUTO_REMOVE_TIME) {
        setSearchOrderValue(storedSearchName);
        orderSearch(storedSearchName);
      } else {
        //  sessionStorage.removeItem("searchName");
        //  sessionStorage.removeItem("searchTimestamp");
      }
    }
  }, []);

  useEffect(() => {
    return () => {
      // sessionStorage.removeItem("searchName");
    };
  }, []);

  const onSearchClick = () => {
    if (searchOrderValue && searchOrderValue.length >= 4) {
      setIsLoading(true);
      setSelectedCity(null);
      setSelectedAmounts(null);
      setFilteredCityList(null);

      orderSearch(searchOrderValue);
    } else {
      displayErrorToast("Please enter at least 4 characters.");
    }
  };

  const onSearchInputKeyDown = (e) => {
    if (e.keyCode === 13) {
      if (searchOrderValue && searchOrderValue.length >= 4) {
        setIsLoading(true);
        setSelectedCity(null);
        setSelectedAmounts(null);
        setFilteredCityList(null);

        orderSearch(searchOrderValue);
      } else {
        displayErrorToast("Please enter at least 4 characters.");
      }
    }
  };

  const removeDuplicates = (list, key) => {
    if (!list || list.length === 0) {
      return [];
    }

    return Array.from(new Set(list.map((item) => item[key]))).map(
      (uniqueKey) => {
        return list.find((item) => item[key] === uniqueKey);
      }
    );
  };

  const handleCheckboxChange = (value, type) => {
    if (type === "city") {
      const newSelectedCity = selectedCity === value ? null : value;
      setSelectedCity(newSelectedCity);

      if (newSelectedCity === null) {
        orderSearch(searchOrderValue);
      }
    } else if (type === "amount") {
      const newSelectedAmount = selectedAmount === value ? null : value;
      setSelectedAmounts(newSelectedAmount);

      if (newSelectedAmount === null) {
        orderSearch(searchOrderValue);
        
      }
     
    }
    handleClose()
  };

  const handleOpen = () => {
    setOpenFilter(true);
  };

  const handleOpenAmount = () => {
    setOpenFilterAmount(true);
  };

  useEffect(() => {
    if (selectedCity || selectedAmount) {
      let queryParams = "";

      if (selectedCity) {
        queryParams += `&city=${selectedCity}`;
      }

      if (selectedAmount) {
        queryParams += `&amount=${selectedAmount}`;
      }

      if (queryParams) {
        props.getDataFromAPI(
          `/partner/api/v1/admin/orders?search_query=${searchOrderValue}&page_number=0&page_size=20&from_timestamp=${fromTimestampFormatted}&to_timestamp=${toTimestampFormatted}${queryParams}`,
          "GET",
          null,
          (response) => {
            setSearchOrderList(response);
          }
        );
      }
    }
  }, [selectedCity, selectedAmount]);

  console.log("filter city data", filteredCityList);

  const handleClose = () => {
    setOpenFilter(false);
    setOpenFilterAmount(false);
  };
  console.log("serach city", cityData);
  const currentDate = new Date();
  const toTimestamp = currentDate.toISOString();

  currentDate.setDate(currentDate.getDate() - 30);
  const fromTimestamp = currentDate.toISOString();

  const fromTimestampFormatted = fromTimestamp.slice(0, 19).replace("T", " ");
  const toTimestampFormatted = toTimestamp.slice(0, 19).replace("T", " ");

  const displayErrorToast = (message) => {
    toastr.error(message);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const queryType = searchParams.get("query_type");
    const storedSearchValue = localStorage.getItem("searchOrderValue");

    if (queryType && storedSearchValue) {
      setSearchOption(queryType);
      setSearchOrderValue(storedSearchValue);

      orderSearch(storedSearchValue);
    }
  }, [location.search]);

  const orderSearch = async (searchOrderValue, event) => {
    setSearchOrderData(searchOrderValue);

    if (searchOrderValue && searchOrderValue.length >= 4) {
      let queryType = "";
      if (searchOption === "phone") {
        queryType = "phone";
      } else if (searchOption === "order_id") {
        queryType = "order_id";
      } else if (searchOption === "dcCode") {
        queryType = "dcCode";
      }

      const url = `/partner/api/v1/admin/orders/?search_query=${searchOrderValue}&page_number=0&page_size=20&from_timestamp=${fromTimestampFormatted}&to_timestamp=${toTimestampFormatted}`;

      try {
        setIsLoading(true);

        const response = await new Promise((resolve, reject) => {
          props.getDataFromAPI(
            url,
            "GET",
            "undefined",
            (response) => resolve(response),
            (err) => reject(err)
          );
        });

        console.log("Get response order search ", response);
        setSearchOrderList(response);
        // setFilteredCityList(null);
        setFilteredAmountList(null);
      } catch (error) {
        console.error("Failed to fetch data: ", error);
        displayErrorToast("Failed to fetch data. Please try again.");
      } finally {
        setIsLoading(false);
      }
    } else {
      setSearchOrderList([]);
      setIsLoading(false);
      if (searchOrderValue) {
        if (searchOption === "phone") {
          displayErrorToast(
            "Invalid phone number. Please enter at least 4 digits."
          );
        } else if (searchOption === "order_id") {
          displayErrorToast(
            "Invalid order ID. Please enter at least 4 characters."
          );
        } else if (searchOption === "dcCode") {
          displayErrorToast("Invalid DC Code. Please enter at least 4 digits");
        }
      }
    }
  };

  const filteredList = filteredAmountList
    ? filteredAmountList
    : filteredCityList && filteredCityList
    ? filteredCityList && filteredCityList
    : searchOrderData && searchOrderData.length >= 4
    ? searchOrderList &&
      searchOrderList.filter((order) => {
        const lowerCaseSearchValue = searchOrderData.toLowerCase();
        if (
          order &&
          ((order.phone || "").includes(lowerCaseSearchValue) ||
            (order.order_id || "").includes(lowerCaseSearchValue) ||
            (order.dcCode || "").includes(lowerCaseSearchValue))
        ) {
          return true;
        }
        return true;
      })
    : [];

  const tableContainerRef = useRef(null);
  // useEffect(() => {
  //   loadingRef.current = loading;
  // }, [loading]);

  useEffect(() => {
    loadingRef.current = isLoading;
  }, [isLoading]);

  const fetchOrderListNext = useCallback(
    (page) => {
      console.log("Fetching data for page:", page);

      if (loadingRef.current) return;

      setLoading(true);

      props.getDataFromAPI(
        `/partner/api/v1/admin/orders/?search_query=${searchOrderValue}&page_number=${page}&page_size=20&from_timestamp=${fromTimestampFormatted}&to_timestamp=${toTimestampFormatted}`,
        "GET",
        undefined,
        (response) => {
          console.log("API response:", response);
          if (response && response.length > 0) {
            setSearchOrderList((prevData) => [...prevData, ...response]);
            setMorescroll(response.length === 20);
            setStart(page);
          } else {
            setMorescroll(false);
          }
          setLoading(false);
        },
        (err) => {
          setIsLoading(false);
          console.log("err refund api ", err.message);
          toastr.error(`${err.message}`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });
        }
      );
    },
    [searchOrderValue, props, fromTimestampFormatted, toTimestampFormatted]
  );

  const handleScroll = () => {
  const container = tableContainerRef.current;

  if (container) {
    const { scrollTop, clientHeight, scrollHeight } = container;

    if (!loadingRef.current && !filtering && morescroll && scrollTop + clientHeight >= scrollHeight - 50) {
      console.log("Fetching next page");
      fetchOrderListNext(start + 1);
    }
  }
};
  const throttledHandleScroll = useCallback(throttle(handleScroll, 200), [
    handleScroll,
  ]);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      container.addEventListener("scroll", throttledHandleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", throttledHandleScroll);
      }
    };
  }, [throttledHandleScroll]);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
      const handleDateChange = (newValue) => {
        setPickDate(newValue ? moment(newValue).tz("IST") : null);
      };
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target.result);
        setImageDropped(true);
        setImagePath(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onButtonClick = (e, type) => {
    if (type === "box") {
      inputRef.current.click();
    }
  };

  const handleClickImg = () => {
    if (imagePath !== "") {
      setLoading(true);
      setShowFileInput(false);

      Tesseract.recognize(imagePath, "eng", {
        logger: (m) => console.log(m),
      })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        })
        .then((result) => {
          const words = result.data.words;
          let orderIdFound = false;

          words.forEach((word) => {
            const parts = word.text.split(/[_#]/);
            const relevantText = parts[parts.length - 1];

            if (
              relevantText.length === 16 &&
              /^[A-Za-z0-9]*$/.test(relevantText)
            ) {
              let correctedText = relevantText.replace(/O/g, "0");
              setOrderID(correctedText);
              console.log("Corrected text:", correctedText);
              navigate(`/home/ordersview/${correctedText}`);
              orderIdFound = true;
            }
          });

          setText(words);
          setOrderFound(orderIdFound);
          if (!orderIdFound) {
            setOrderID("-1");
          }
          setLoading(false);
        });
    }
  };
  const handleChangeImage = (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0) {
      setPreviewImage(null);
      setImageDropped(false);
      return;
    }

    const file = e.target.files[0];
    setSelectedFile(file);

    setImagePath(URL.createObjectURL(file));
    const reader = new FileReader();
    reader.onload = (e) => {
      setPreviewImage(e.target.result);
      setImageDropped(true);
    };
    reader.readAsDataURL(file);
    setShowFileInput(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloseD = () => {
    setOpen(false);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleRetry = () => {
    setOrderFound(true);
    setOrderId("");
    setImagePath("");
    setPreviewImage(null);
    setImageDropped(false);
    setSelectedFile(null);
    setShowFileInput(true);
  };

  return (
    <OrdersListComp
      filteredList={filteredList}
      filteredCityList={filteredCityList}
      orderSearch={orderSearch}
      onSearchInputChange={onSearchInputChange}
      // loading={loading}
      fetchNextOrderlist={fetchOrderListNext}
      data={data}
      morescroll={morescroll}
      handleDateChange={handleDateChange}
      SelectedDate={SelectedDate}
      pickDate={pickDate}
      rowColors={rowColors}
      handleDrag={handleDrag}
      handleDrop={handleDrop}
      // handleChange={handleChange}
      onButtonClick={onButtonClick}
      dragActive={dragActive}
      inputRef={inputRef}
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
      previewImage={previewImage}
      imageDropped={imageDropped}
      open={open}
      orderId={orderID}
      handleCloseD={handleCloseD}
      handleChangeImage={handleChangeImage}
      handleClickOpen={handleClickOpen}
      handleClickImg={handleClickImg}
      orderFound={orderFound}
      handleRetry={handleRetry}
      retryClicked={retryClicked}
      showFileInput={showFileInput}
      handleFocus={handleFocus}
      isFocused={isFocused}
      handleBlur={handleBlur}
      searchOrderData={searchOrderData}
      searchOrderValue={searchOrderValue}
      onSearchClick={onSearchClick}
      onSearchInputKeyDown={onSearchInputKeyDown}
      isLoading={isLoading}
      handleSearchOptionChange={handleSearchOptionChange}
      searchOption={searchOption}
      tableContainerRef={tableContainerRef}
      // orderSearchViaCity={orderSearchViaCity}
      searchCityValue={searchCityValue}
      handleClose={handleClose}
      handleOpen={handleOpen}
      // handleInputChange={handleInputChange}
      openFilter={openFilter}
      handleOpenAmount={handleOpenAmount}
      openFilterAmount={openFilterAmount}
      searchAmountValue={searchAmountValue}
      filteredAmountList={filteredAmountList}
      cityList={cityList}
      handleApply={handleApply}
      startTime={startTime}
      setStartTime={setStartTime}
      endTime={endTime}
      setEndTime={setEndTime}
      handleCancelSelection={handleCancelSelection}
      handleStartTimeChange={handleStartTimeChange}
      handleEndTimeChange={handleEndTimeChange}
      handleFilterClick={handleFilterClick}
      handleCheckboxChange={handleCheckboxChange}
      selectedCity={selectedCity}
      selectedAmount={selectedAmount}
      removeDuplicates={removeDuplicates}
      handleApplyFilter={handleApplyFilter}
      handleAmountInputChange={handleAmountInputChange}
    />
  );
};
function mapStateToProps({ props }) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
  setLoading,
  setCityFilter,
  setAmountFilter,
})(OrderListContainer);
